import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { generateSEOMeta } from '@/components/feature/SEOMeta';
import { getOrganizationSchema, getWebSiteSchema, getWebPageSchema } from '@/components/feature/JsonLD';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import PopularComics from './components/PopularComics';
import LatestUpdates from './components/LatestUpdates';
import Testimonials from './components/Testimonials';

const seo = generateSEOMeta('home');

export default function Home() {
  useEffect(() => {
    document.title = seo.title;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', seo.description);
    const metaKw = document.querySelector('meta[name="keywords"]');
    if (metaKw) metaKw.setAttribute('content', seo.keywords);
  }, []);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(getOrganizationSchema()) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(getWebSiteSchema()) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(getWebPageSchema(seo.title, seo.description, 'https://www.hanmanzhijia.com/')) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <PopularComics />
          <LatestUpdates />
          <Testimonials />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}